import * as Style from "../style/StyledComponents";
import { abbreviateAddress, chain, getEtherscanAddressLink, getEtherscanTxnLink, getEtherscanContractLink, links, data as configData } from "./Config";
import {useState, useEffect} from 'react'

import { InjectedConnector } from 'wagmi/connectors/injected'
import { useConnect , useAccount, useDisconnect } from 'wagmi'
import { usePrepareContractWrite, useContractWrite , useContractReads  } from 'wagmi'
import { waitForTransaction, fetchBalance  } from '@wagmi/core'

import { ethers } from 'ethers';
import BigNumber from 'bignumber.js';
import ConnectWalletButton from "./ConnectWalletButton";

import { getMerkleRoot, containsAddressInList, getMerkleProof } from "../merkle/merkle";
import { merkleRoot as merkleRootPrecalc } from "../merkle/addresses";
import imgEgg from "../images/egg.png";

BigNumber.config({ EXPONENTIAL_AT: 50 })

const contractAbi = require("../abi/Derplets.json").abi;

const frontendContract = {
  address: process.env.REACT_APP_CONTRACT_ERC721,
  abi: contractAbi,
}


const MINT_STATUS = {
  Disabled:0,
  Allowlist:1,
  Public:2
}

const MINT_STATUS_NAMES = [
  <span>Paused</span>,
  <span>📋 Whitelist Only</span>,
  <span>Public</span>,
];

function Egg() {
  return (
      <img style={{width:"25px", userSelect:"none"}} draggable="false" src={imgEgg} />
  )
}

export const Mint = () => {

  const { isConnected , address } = useAccount()
  const { disconnect } = useDisconnect()
  const { connectors, connect } = useConnect({
    connector: new InjectedConnector({chains:[chain]}),
    chainId: chain.id,
  });

  // from contract
  const [currentSupply, setCurrentSupply] = useState(0);
  const [maxSupply, setMaxSupply] = useState(3333);
  const [publicMintPrice, setPublicMintPrice] = useState("0.005");
  const [allowlistMintPrice, setAllowlistMintPrice] = useState("0.0035");
  const [mintStatus, setMintStatus] = useState(0);
  const [maxPerWalletPublic, setMaxPerWalletPublic] = useState(0);
  const [maxPerWalletAllowlist, setMaxPerWalletAllowlist] = useState(0);
  const [numMintedByAddress, setNumMintedByAddress] = useState(0);
  const [numClaimableByAddress, setNumClaimableByAddress] = useState(0);
  const [merkleRoot, setMerkleRoot] = useState("");
  
  const [mintCount, setMintCount] = useState(1);
  const [maxMintAmount, setMaxMintAmount] = useState(1);
  const [mintPrice, setMintPrice] = useState("0.005");
  const [walletBalance, setWalletBalance] = useState("0.0");
  const [merkleRootLocal, setMerkleRootLocal] = useState("");

  const addressIsWhitelisted = containsAddressInList(address);
  const canClaim = numClaimableByAddress > 0;

  // calculated
  const [totalMintPrice, setTotalMintPrice] = useState("0.0");

  const { data:readData, isError:readError, isLoading:readIsLoading } = useContractReads({
    enabled: isConnected && address != null,
    contracts: [
      {
        ...frontendContract,
        functionName: 'totalMinted',
      },
      {
        ...frontendContract,
        functionName: 'MAX_SUPPLY',
      },
      {
        ...frontendContract,
        functionName: 'maxPerWalletPublic',
      },
      {
        ...frontendContract,
        functionName: 'maxPerWalletAllowlist',
      },
      {
        ...frontendContract,
        functionName: 'mintStatus',
      },
      {
        ...frontendContract,
        functionName: 'publicPrice',
      },
      {
        ...frontendContract,
        functionName: 'allowlistPrice',
      },
      {
        ...frontendContract,
        functionName: 'merkleRoot',
      },
      {
        ...frontendContract,
        functionName: 'getNumMintedByWallet',
        args: [address],
      },

      {
        ...frontendContract,
        functionName: 'getClaimableCount',
        args: [address],
      },
    ],
  });

  async function checkBalance() {
     const balance = await fetchBalance({
        address: address,
      });

      const price = new BigNumber(parseInt(balance.value));
      const total = price.multipliedBy("1E-18");
      setWalletBalance(total.toString());

      console.log(balance);
  }

  useEffect(()=>{

    if (isConnected && address) {
      checkBalance();
    }
  }, [address,isConnected]);

  useEffect(()=>{
    if (readData != null) {
      console.log("Contract read:", readData);

      const _maxPerWalletPublic = parseInt(readData[2].result);
      const _maxPerWalletAllowlist = parseInt(readData[3].result);
      const _numMintedByAddress = parseInt(readData[8].result);
      const _numClaimableByAddress = parseInt(readData[9].result);
      const _mintStatus = parseInt(readData[4].result);

      setCurrentSupply( parseInt(readData[0].result));
      setMaxSupply( parseInt(readData[1].result));
      setMaxPerWalletPublic(_maxPerWalletPublic);
      setMaxPerWalletAllowlist(_maxPerWalletAllowlist);
      setMintStatus(_mintStatus);
      setNumMintedByAddress(_numMintedByAddress);
      setNumClaimableByAddress(_numClaimableByAddress);
      setMerkleRoot(readData[7].result);

      // public price
      const pricePublic = new BigNumber(parseInt(readData[5].result));
      const totalPublic = pricePublic.multipliedBy("1E-18");
      setPublicMintPrice(totalPublic.toString());

      // allowlist price
      const priceAllowlist = new BigNumber(parseInt(readData[6].result));
      const totalAllowlist = priceAllowlist.multipliedBy("1E-18");
      setAllowlistMintPrice(totalAllowlist.toString());

      console.log(`ALLOWLIST: ${addressIsWhitelisted}, totalAllowlist: ${totalAllowlist}, totalPublic: ${totalPublic}`);

      // max price
      const currentMaxSupply = addressIsWhitelisted ? _maxPerWalletAllowlist : _maxPerWalletPublic;
      setMaxMintAmount( Math.max(currentMaxSupply-_numMintedByAddress, 0));
      setMintCount(Math.min(1, currentMaxSupply));

      // mint price
      setMintPrice( addressIsWhitelisted ? totalAllowlist.toString() : totalPublic.toString());
    }

  }, readData);

  const { data, isLoading, isSuccess, error, isError, write, reset } = useContractWrite({
    address: process.env.REACT_APP_CONTRACT_ERC721,
    abi: contractAbi,
    functionName: addressIsWhitelisted ? 'allowlistMint':'mint',
    chainId: chain.id,
    account: address,

    onSettled(data, error) {
      console.log('Transaction Settled', { data, error })
    },
  });

  // FREE CLAIM
  const { data: dataClaim, isLoading: isLoadingClaim, isSuccess: isSuccessClaim, error: errorClaim, isError: isErrorClaim, write: writeClaim, reset: resetClaim } = useContractWrite({
    address: process.env.REACT_APP_CONTRACT_ERC721,
    abi: contractAbi,
    functionName: 'claim',
    chainId: chain.id,
    account: address,

    onSettled(data, error) {
      console.log('Transaction Settled', { data, error })
    },
  });

  useEffect(()=>{
    const price = new BigNumber(mintPrice);
    const total = price.multipliedBy(mintCount);
    setTotalMintPrice(total.toString());
  },  [mintPrice, mintCount]);

  useEffect(()=>{
    const _merkleLocal = merkleRootPrecalc;//getMerkleRoot();
    setMerkleRootLocal(_merkleLocal);
    console.log(`Local merkle root: ${_merkleLocal}`);
  },  []);


  function onClickPlus() {
    setMintCount(Math.min(maxMintAmount, mintCount+1));
  }

  function onClickMinus() {
    setMintCount(Math.max(1, mintCount-1));
  }

  function onClickConnect() {
    console.log("CONNECT");
    connect();
  }

  function onClickDisconnect() {
    console.log("Disconnect");
    disconnect();
    reset();
    resetClaim();
  }

  async function onClickClaim() {
    resetClaim();

    const args = [];
    console.log(`claim(${address})`);

    writeClaim({
          args: args,
          from: address,
          //value: ethers.parseEther(totalMintPrice),
    });
  }

  async function onClickPublicMint() {
    reset();

    const args = addressIsWhitelisted ? [mintCount, getMerkleProof(address)] : [mintCount];
    console.log(`${addressIsWhitelisted? "allowListMint()": "mint()" } with numMints: ${mintCount}, payable: ${totalMintPrice} ETH, args:[${args}]`);

    write({
          args: args,
          from: address,
          value: ethers.parseEther(totalMintPrice),
    });
  }

  return (
    <div>


    {<>
        <Style.Button disabled>minted out!</Style.Button>
        <p style={{marginTop:"5px"}}>✔️ {maxSupply}/{maxSupply}<br/>( buy on <a href={links.magicEden} target="_blank">magic eden</a> / <a href={links.mintify} target="_blank">mintify</a> )</p>
      </>}

{/*
    {configData.hidden && <><Style.Button disabled={false}>mint soon!</Style.Button><p>available jan 27 (<a href={links.abstract} target="_blank">Abstract</a> launch day)</p></>}

    {!isConnected && !configData.hidden && <><ConnectWalletButton>connect</ConnectWalletButton></>}

    {isConnected && canClaim && currentSupply < maxSupply && 
      <>
        <p>🐸 BASED FROG CHAD! 🐸<br/>You can claim {numClaimableByAddress} derplets for FREE!!</p>
        <Style.Button disabled={isLoadingClaim || numClaimableByAddress == 0} onClick={onClickClaim}>claim 🥚{numClaimableByAddress} (free)</Style.Button>
       

        {isErrorClaim && <Style.ErrorMessage>Error: {errorClaim.message}</Style.ErrorMessage>}
        {isSuccessClaim && dataClaim != null && <Style.SuccessMessage><strong>✔️ Transaction Sent</strong>: <a href={getEtherscanTxnLink(dataClaim.hash)} target="_blank">{abbreviateAddress(dataClaim.hash, 8)}</a>.<br/><br/>Please refresh page after transaction is complete.</Style.SuccessMessage>}
        <br/><br/><hr/><br/>
      </>
    }


    {isConnected && mintStatus==MINT_STATUS.Disabled && <Style.Button disabled={true}>minting not available</Style.Button>}
    {isConnected && mintStatus!=MINT_STATUS.Disabled && currentSupply == maxSupply && <Style.Button disabled={true}>✔️ minted out!</Style.Button>}
    {isConnected && mintStatus==MINT_STATUS.Allowlist && currentSupply < maxSupply && !addressIsWhitelisted && <Style.Button disabled={true}>currently WL only (sorry)</Style.Button>}

    {isConnected && maxMintAmount >0 && <p style={{marginBottom:"5px"}}>{addressIsWhitelisted && <strong>🤙 Ayy, you're whitelisted!</strong>}</p>
    }

    {isConnected && mintStatus != MINT_STATUS.Disabled && maxMintAmount ==0 && 
      <>
      <Style.Button disabled={true}>no more mints left..</Style.Button>
      <p>you max minted {numMintedByAddress}!</p>
      </>
    }
    {isConnected && maxMintAmount > 0 && (mintStatus==MINT_STATUS.Public || (mintStatus==MINT_STATUS.Allowlist && addressIsWhitelisted)) && currentSupply < maxSupply && 
      <div style={{textAlign:"left"}}>
      <div style={{display:"flex", flexDirection:"row"}}>
        <Style.Button disabled={isLoading || isLoadingClaim} hidden={mintCount<=1} onClick={onClickMinus}>-</Style.Button>
        <Style.Button disabled={isLoading || isLoadingClaim || mintCount == 0 || maxMintAmount == 0} onClick={onClickPublicMint}>mint 🥚{mintCount} {addressIsWhitelisted && " (WL)"}</Style.Button>
        <Style.Button disabled={isLoading || isLoadingClaim} hidden={mintCount>=maxMintAmount || (currentSupply+mintCount+1 > maxSupply) } onClick={onClickPlus}>+</Style.Button>
        </div>


      
         <div>
        <div style={{fontSize:"1em", color: "#888", marginTop:"5px"}}>🥚{mintCount} (of 🥚{maxMintAmount}) x {mintPrice} Ξ each</div>
        <div style={{fontSize:"1.25em", marginBottom:"40px", fontFamily:"Header", fontWeight:"bold", color: "var(--text)"}}>✔️ Total: <span style={{fontSize:"1.3em", color: "var(--text)", fontWeight:"bold"}}>{totalMintPrice} Ξ</span></div>
    </div>

    </div>
      }

      */}


    {isConnected && <div style={{marginTop:"1.5em", fontSize:"1em",textAlign:"left",}}>🟢 <strong>You're Connected</strong>!</div>}

    {isConnected && <div style={{fontSize:"1em",textAlign:"left",}}>
      <p>▪ Your Wallet: <a href={getEtherscanAddressLink(address)} target="_blank">{abbreviateAddress(address, 5)}</a> (<a onClick={onClickDisconnect}>Disconnect</a>)</p>
      <p>▪ Your Balance: <strong>{parseFloat(walletBalance).toPrecision(5)} Ξ</strong> ({chain.name})</p>
      <p>▪ Your Mints: <strong>{numMintedByAddress}</strong> (remaining: <strong>{Math.max(maxMintAmount,numClaimableByAddress)}</strong>)</p>
    </div>}

    {isConnected && 
      <div style={{marginTop:"1.2em", fontSize:"1em", textAlign:"left"}}>
        <strong>Token Info:</strong>
        <br/>
        ▪ Network: <strong><a href={links.abstract} target="_blank">{chain.name}</a></strong>
        <br/>
        ▪ Mint Status: <strong>{MINT_STATUS_NAMES[mintStatus]}</strong>
        <br/>
        ▪ Total Minted: {currentSupply==maxSupply?"✔️ ":""}<strong>{currentSupply} / {maxSupply}</strong>
        <br/>
        ▪ {addressIsWhitelisted && 'Whitelist'} Mint Price (each): <strong>{mintPrice} Ξ</strong>
        {/*
        <br/>
        ▪ Num Claimable by You: <strong>{numClaimableByAddress}</strong>
        <br/>
        ▪ Max Per Wallet: <strong>{maxPerWalletPublic}</strong> ({maxPerWalletAllowlist} for WL)
        */}
        <br/>
        ▪ Contract: <a href={links.contractFrontEnd} target="_blank">{abbreviateAddress(process.env.REACT_APP_CONTRACT_ERC721,4)}</a>
        <br/>
        ▪ Merkle Root: <strong>{abbreviateAddress(merkleRoot,3)}</strong> (local: {abbreviateAddress(merkleRootLocal, 3)})
      </div>
    }


    {isError && <Style.ErrorMessage>Error: {error.message}</Style.ErrorMessage>}

    {isSuccess && data != null && <Style.SuccessMessage><strong>✔️ Transaction Sent</strong>: <a href={getEtherscanTxnLink(data.hash)} target="_blank">{abbreviateAddress(data.hash, 8)}</a><br/><br/>Please refresh page after transaction is complete.</Style.SuccessMessage>}

    </div>
  )
}
